import React from 'react'

import { Skeleton } from '@/components/ui/skeleton'

function CommentItemSkeleton({ isReply = false, level = 0 }: { isReply?: boolean; level?: number }) {
  return (
    <div className={`relative flex gap-2 ${isReply ? 'ml-4 sm:ml-8 md:ml-10' : ''}`}>
      {/* Connection line for replies */}
      {isReply && (
        <div
          className="absolute -left-3 sm:-left-5 md:-left-6 top-4 w-3 sm:w-5 md:w-6 border-l-2 border-b-2 h-6 border-gray-200 rounded-bl-xl hidden xs:block"
          style={{
            borderLeftWidth: '2px',
            borderBottomWidth: '2px',
            borderColor: `rgba(209, 213, 219, ${Math.max(0.8 - level * 0.2, 0.3)})`,
          }}
        />
      )}

      {/* Avatar skeleton */}
      <Skeleton className="h-6 w-6 sm:h-8 sm:w-8 rounded-full flex-shrink-0 mt-1" />

      <div className="flex flex-col flex-1 min-w-0 space-y-2">
        {/* Comment bubble skeleton */}
        <div className={`bg-gray-100 rounded-2xl px-3 py-2 ${isReply ? 'bg-opacity-80' : ''}`}>
          <Skeleton className="h-3 sm:h-4 w-20 sm:w-24 mb-1" />
          <div className="space-y-1">
            <Skeleton className="h-3 sm:h-4 w-full" />
            <Skeleton className="h-3 sm:h-4 w-3/4" />
          </div>
        </div>

        {/* Action buttons skeleton */}
        <div className="flex items-center gap-2 sm:gap-4">
          <Skeleton className="h-3 w-12" />
          <Skeleton className="h-3 w-8" />
          <Skeleton className="h-3 w-10" />
        </div>
      </div>
    </div>
  )
}

export function CommentsSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index}>
          <CommentItemSkeleton />
          {/* Randomly show some reply skeletons for more realistic appearance */}
          {Math.random() > 0.6 && (
            <div className="mt-2 space-y-2">
              <CommentItemSkeleton isReply={true} level={1} />
              {Math.random() > 0.7 && <CommentItemSkeleton isReply={true} level={2} />}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export function LoadMoreCommentsSkeleton() {
  return (
    <div className="space-y-3">
      {Array.from({ length: 3 }).map((_, index) => (
        <CommentItemSkeleton key={index} />
      ))}
    </div>
  )
}
